// extracted by mini-css-extract-plugin
module.exports = {"container_Nav":"Paginado_container_Nav__1yqJP","div_Num":"Paginado_div_Num__2wYnT","numbers":"Paginado_numbers__2cywX"};